The details of the updated webhook subscription.
